var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.loadingDetails
        ? _c("h1", { attrs: { id: "heading" } }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("account.registration.pageTitle")) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(_vm.currentStep, {
        tag: "component",
        staticClass: "form-page",
        attrs: {
          email: _vm.email,
          "is-broker-invitation": _vm.isBrokerInvitation,
          loading: _vm.loading,
          "loading-status": _vm.loadingStatus,
          "loading-details": _vm.loadingDetails,
        },
        on: {
          "update:isBrokerInvitation": function ($event) {
            _vm.isBrokerInvitation = $event
          },
          "update:is-broker-invitation": function ($event) {
            _vm.isBrokerInvitation = $event
          },
          "update:loadingDetails": function ($event) {
            _vm.loadingDetails = $event
          },
          "update:loading-details": function ($event) {
            _vm.loadingDetails = $event
          },
          "show-login": _vm.showLoginPage,
          login: _vm.login,
          "sign-up": _vm.createAccount,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }